import { render, staticRenderFns } from "./BulmaNotification.vue?vue&type=template&id=5dad0260&"
import script from "./BulmaNotification.vue?vue&type=script&lang=js&"
export * from "./BulmaNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports